import styled from 'styled-components'

export const DateLabel = styled.h5`
  margin-top: 0.15rem;
  margin-bottom: 0px;
`



// WEBPACK FOOTER //
// ./src/components/Styled.tsx